import React, { useEffect, useState } from 'react';
import { Box } from 'lucide-react';
import { apiBaseUrl } from '../../services/api';

// Vignette d'une conception Fusion, gardée par Deepflow au relevé de nuit (la route demande l'authentification : l'image
// est chargée avec le jeton puis affichée depuis la mémoire du navigateur).
const CadThumb = ({ projectId, itemId, version, available = true, className = 'h-24 w-24' }) => {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!available || !itemId || version == null) return undefined;
    let url = null;
    let cancelled = false;
    const token = localStorage.getItem('auth_token');
    fetch(`${apiBaseUrl}/projects/${projectId}/fusion/thumbnail/${version}?item_id=${encodeURIComponent(itemId)}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }).then((response) => (response.ok ? response.blob() : null)).then((blob) => {
      if (!blob || cancelled) return;
      url = URL.createObjectURL(blob);
      setSrc(url);
    }).catch(() => {});
    return () => { cancelled = true; if (url) URL.revokeObjectURL(url); };
  }, [projectId, itemId, version, available]);

  return (
    <div className={`flex shrink-0 items-center justify-center overflow-hidden rounded-xl border border-slate-200 bg-slate-50 ${className}`}>
      {src ? <img src={src} alt="" className="h-full w-full object-contain" /> : <Box size={22} className="text-slate-300" />}
    </div>
  );
};

export default CadThumb;
